import React, { useEffect, useState } from 'react';
import setUiMessage from '../Utilities/Tostify';
import { preLineClass } from '../Utilities/Utilities';
import { post } from './Auths/AuthToken';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../constents';
import PrintLayout from './Layouts/PrintLayout';
import CounselingPrintPopup from './Patient/CounselingPrintPopup';
import ReactDOMServer from 'react-dom/server';
import SoapPrintPopup from './Patient/SoapPrintPopup';
import AddendumPopup from './Patient/AddendumPopup';
import ProofOfAppPopup from './Patient/ProofOfAppPopup';
import RevisionHxListPopup from './Patient/RevisionHxListPopup';
import { setUnlockFlag } from '../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';
import Button from './Button';

function PatientPrgressReport({
  soapId,
  patientId,
  appId,
  visit_id = false,
  close,
  handleReload,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);

  const [allData, setAllData] = useState(false);
  const [addendum, setAddendum] = useState(false);
  const [poaPopup, setPoaPopup] = useState(false);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [revHxPopup, setRevHxPopup] = useState({
    status: false,
    soapId: null,
  });
  const soapButtonList = Array.isArray(allData?.soapButtonList)
    ? allData.soapButtonList.map(String)
    : allData?.soapButtonList && typeof allData.soapButtonList === 'object'
      ? Object.values(allData.soapButtonList).map(String)
      : [];
  const hasSoapBtn = (code) => soapButtonList.includes(code);


  useEffect(() => {
    (async () => {
      try {
        if (patientId && appId && visit_id) {
          const response = await post(
            'api/patient/progressNote/manageCounselingNote',
            {
              patientId: patientId,
              appointmentId: appId,
              visitId: visit_id,
              staffUserId: user?.id,
              mode: '',
            },
          );
          if (response.status === 200) {
            setAllData(response?.data);
            setLoading(false);
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, appId, visit_id, reload, user?.id]);

  const handleChageCounsellingNote = async (type) => {
	  if (type === 'unlock' && !hasSoapBtn('UCH')) {
      setUiMessage('err', 'You are not authorized to unlock this note.');
      return;
    }
    if (type !== 'unlock' && !hasSoapBtn('O') && !hasSoapBtn('CH')) {
      setUiMessage('err', 'You are not authorized to change this note.');
      return;
    }
    try {
      const response = await post('api/patient/progressNote/noteUnlockChange', {
        soapId: soapId,
        loginUserId: user?.id,
      });
      if (response?.status === 200) {
        if (type === 'unlock') {
          dispatch(setUnlockFlag('unlock'));
        } else {
          dispatch(setUnlockFlag('unlock'));
        }
        navigate(
          `${DEFAULT_LOCAL_PATH}/patient/counNote/${patientId}/${appId}/${allData?.visitId}?flag=true`,
          {
            replace: true,
          },
        );
        close();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCounsellingSign = async (soapId) => {
	  if (!hasSoapBtn('SN')) {
      setUiMessage('err', 'You are not authorized to sign this note.');
      return;
    }
    const genDetailId = allData?.progressNoteItem
      ?.filter((data) => data?.variable_name === 'general_detail')
      ?.map((c) => c?.id);

    if (
      allData?.defaultSaveItem[genDetailId[0]]?.genDetail?.length === 0 ||
      allData?.defaultSaveItem[genDetailId[0]]?.genDetail?.procName.length === 0
    ) {
      setUiMessage(
        'err',
        'Please add procedure code in general detail section.',
      );
      return;
    }

    try {
      const response = await post('api/patient/progressNote/saveSignInDate', {
        soapId: soapId,
        staffUserId: user?.id,
      });
      if (response.status === 200) {
        handleReload();
        close();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handlePrint = async () => {
    try {
      if (!patientId || !appId || !visit_id) return;
      const printContent = getPrintContent(allData);

      const newWindow = window.open('', '_blank', 'height=700,width=900');
      if (!newWindow) {
        setUiMessage(
          'war',
          'Popup blocked! Please allow popups for this website.',
        );
        return;
      }

      newWindow.document.write(printContent);
      newWindow.document.close();
      setTimeout(() => newWindow.print(), 0);
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const getPrintContent = (data) => {
    const { noteType, printHeaderFooterInfo, typeOfVisit } = allData;
    const layout = (
      <PrintLayout headerFooterInfo={printHeaderFooterInfo}>
        {noteType === '3' ? (
          <CounselingPrintPopup allData={data} template={typeOfVisit} />
        ) : (
          noteType === '2' && <SoapPrintPopup allData={allData} />
        )}
      </PrintLayout>
    );
    let printContent = ReactDOMServer.renderToString(layout);

    // Include a <link> tag to reference the external CSS file
    printContent = `
        <html>
            <head>
                <link rel="stylesheet" type="text/css" href="${DEFAULT_LOCAL_PATH}/styleprint.css">
            </head>
            <body>${printContent}</body>
        </html>
    `;

    return printContent;
  };

  const handleCoSign = async () => {
    try {
      const response = await post('api/notes/progressNote/coSaveSignInDate', {
        soapId: soapId,
        userloginId: user?.id,
      });
      if (response.status === 200) {
        handleReload();
        close();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleOpenRevHxPopUp = (soapId) => {
    setRevHxPopup({
      status: true,
      soapId: soapId,
    });
  };

  return (
    <div className="modalBackground">
      <div
        className="main-contnr prgrs-nt-vw-popup"
        style={{ zIndex: '999' }}
      >
        <div className="flex-sec item-center">
          <div className="hdr-pt-info">
            {allData?.title}
            {allData?.counselorName && <span className="red">{' | '}</span>}
            {allData?.counselorName}
          </div>
          <Button variant="circle" onClick={() => close()}>
            X
          </Button>
        </div>
        <div className="main-contnr-bdy prgrs-nt-vw-bdy">
          <span className="body-label hide">Subjective:</span>
          <span id="printId" className="body-value recrd-nt-rw">
            {loading ? (
              <b>Loading....</b>
            ) : (
              <>
                {(() => {
                  if (allData?.noteType === '2' || allData?.noteType === '3') {
                    let newArray = allData?.saveItemList.filter(
                      (obj) => obj.section_value !== '',
                    );
                    return (
                      allData?.progressNoteItem &&
                      allData?.saveItemList &&
                      newArray.map((section, index) => (
                        <React.Fragment key={index}>
                          {allData?.progressNoteItem.map((item, i) =>
                            item?.id === section?.section_id ? (
                              <div
                                key={i}
                                style={{ borderBottom: '1px dotted #e6e6e6' }}
                              >
                                {item?.variable_name !== 'demographics' ? (
                                  <div className="cntnt-blk-hdng qfrst-sec-lbl qrecrd-nt-prnt-hdng width100">
                                    {item?.preferred_label}
                                  </div>
                                ) : null}
                                <div
                                  className={`cntnt-blk-sb-chld ${preLineClass(
                                    section?.section_value,
                                  )}`}
                                  style={{ paddingLeft: '10px' }}
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: section?.section_value,
                                    }}
                                  />
                                </div>
                              </div>
                            ) : null,
                          )}
                        </React.Fragment>
                      ))
                    );
                  }
                })()}
                {allData?.addendumList.length > 0 && (
                  <div className="addendumBlock">
                    <p style={{ marginLeft: '9px', marginTop: '30px' }}>
                      <strong>Addendum:</strong>
                    </p>
                    {allData?.addendumList?.map((item, i) => {
                      return (
                        <div key={i}>
                          <p style={{ marginLeft: '9px' }}>
                            <b>Provider Name & Credentials: </b>{' '}
                            {item?.ProviderDetail} <br />
                            <b>Original Note Date: </b> {item?.originalNote}{' '}
                            <br />
                            <b>Addendum Date: </b> {item?.addendumDate} <br />
                            <b>Added By: </b> {item?.addedBy} <br />
                            <b>Reason for Addendum: </b> <br />
                            <span
							className={preLineClass(item?.reason)}
                              dangerouslySetInnerHTML={{ __html: item?.reason }}
                            />{' '}
                            <br />
                            <b>Additional Information: </b> <br />
                            <span
							className={preLineClass(item?.description)}
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            />
                          </p>
                          <br />
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </span>
        </div>
        <div
          className="flex-sec justify-between item-center"
          style={{ margin: '5px 15px' }}
        >
          <span className="flex-sec item-center " style={{ width: '55%' }}>
            <span className="width100">
              {(() => {
                if (!allData?.coSignerStr) {
                  return (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: allData?.signStr,
                      }}
                    />
                  );
                } else {
                  return (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: allData?.coSignerStr,
                      }}
                    />
                  );
                }
              })()}
            </span>
            <span className="width100">
              {allData?.rejectStr ? parse(allData?.rejectStr) : ''}
            </span>
          </span>
          <span className="flex-sec gap10">
            <Button variant="outline" onClick={() => close()}>
              Close
            </Button>
            <Button variant="secondary" onClick={handlePrint}>
              Print
            </Button>
            {(hasSoapBtn('O') || hasSoapBtn('CH')) && (
              <Button
                variant="primary"
                onClick={() => handleChageCounsellingNote('')}
              >
                Change
              </Button>
            )}
            {hasSoapBtn('UCH') && (
              <Button
                variant="primary"
                onClick={() => handleChageCounsellingNote('unlock')}
              >
                Unlock & change
              </Button>
            )}
            {hasSoapBtn('ADN') && (
              <Button variant="primary" onClick={() => setAddendum(true)}>
                Addendum
              </Button>
            )}
            {hasSoapBtn('POA') && (
              <Button variant="primary" onClick={() => setPoaPopup(true)}>
                POA
              </Button>
            )}
            {hasSoapBtn('SN') && (
              <Button
                variant="primary"
                onClick={() => handleCounsellingSign(soapId)}
              >
                Sign
              </Button>
            )}
            {hasSoapBtn('CO') && (
              <Button variant="primary" onClick={() => handleCoSign()}>
                Co-Sign
              </Button>
            )}
            {allData?.revHxCount && parseInt(allData?.revHxCount) > 0 && (
              <Button
                variant="primary"
                onClick={() => handleOpenRevHxPopUp(allData?.soapId)}
              >
                Rev. Hx
              </Button>
            )}
            {/* <button className="actn-yes">Fax</button> */}
          </span>
        </div>
      </div>
      {addendum && (
        <AddendumPopup
          soapId={soapId}
          hanleClose={() => setAddendum(false)}
          handleReload={() => setReload(!reload)}
        />
      )}
      {poaPopup && (
        <ProofOfAppPopup
          handleClose={() => setPoaPopup(false)}
          patientId={patientId}
          appId={appId}
          visitId={visit_id}
          soapId={soapId}
          noteType={allData?.noteType}
        />
      )}
      {revHxPopup.status && (
        <RevisionHxListPopup
          soapId={revHxPopup.soapId}
          patientId={patientId}
          appId={appId}
          visitId={allData?.visitId}
          dataForPrint={allData}
          handleClose={() => setRevHxPopup({ status: false, soapId: null })}
        />
      )}
    </div>
  );
}

export default PatientPrgressReport;
